import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

export const RxLpChHeroDescriptionNowSaveModalTrigger: FC<{
  onClick: () => void
}> = ({ onClick }) => {
  const intl = useIntl()

  return (
    <button
      aria-label={intl.formatMessage({
        id: 'general.more.information.short',
      })}
      onClick={onClick}
      type="button"
    >
      <IconInfo className="-mt-0.5 ml-1 inline-block size-4 text-dark-brand" />
    </button>
  )
}
